import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './LoginForm.styles';

import FormError from '../formerror/FormError';
import Image from '../../common/image/Image';
import LoginButton from '../../inputs/loginbutton/LoginButton';
import LoginInput from '../../inputs/logininput/LoginInput';
import Button from '../../inputs/button/Button';

export class LoginFormDomain extends Component {
  render() {
    const { loginError, onBack } = this.props;
    return (
      <form className={css(styles.form)} onSubmit={this.props.handleSubmit}>
        <Image src="https://www.airfinder.com/hubfs/AirFinderAssetv3/AirFinder-v3-logo-white.svg" 
          alt="logo" styles={styles.logo} />
        <Field
          name="password"
          type="password"
          placeholder={I18n.t('login.password')}
          component={LoginInput}
        />
        {loginError && (
          <FormError title={I18n.t('login.errorTitle')}>
            {I18n.t('login.errorBody')}
          </FormError>
        )}
        <Link to="/forgot" className={css(styles.forgot)}>
          {I18n.t('login.resetPassword')}      
        </Link>
        <div className={css(styles.actions, loginError && styles.actionsError)}>
          {onBack && (
            <Button type="button" onClick={onBack}>Back</Button>
          )}
          <LoginButton>{I18n.t('login.login')}</LoginButton>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'login'
})(LoginFormDomain);



// WEBPACK FOOTER //
// ./src/components/forms/loginform/LoginFormPassword.js